"use strict";
import React from "react";
import _ from "underscore";
import ReactUtils from "../../react_utils";
import generalFormatter from "../../formatters/general";
import DropSelector from "./drop_selector";
import Api from "../../api/api";
var bem = ReactUtils.makeBem("shipment-selector");
function formatDropInfo(drop) {
  return [drop.address_line_1 || "", drop.address_line_2 || "", drop.city || ""].filter((_2) => _2).join(", ");
}
export default React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement(
      DropSelector,
      {
        tmsObjects: this.props.tmsShipments,
        tmsObjectDetailsFunction: this.shipment,
        label: "Link with shipment:"
      }
    );
  },
  hasAnyOtherDocumentsFromLoad: function(tmsShipment, documentId) {
    return _.any(
      tmsShipment.shipment_documents,
      (document) => document.id !== documentId && this.props.allDocumentIds.includes(document.id)
    );
  },
  isShipmentDocument: function(tmsShipment, documentId) {
    return _.any(
      tmsShipment.shipment_documents,
      (document) => document.id === documentId
    );
  },
  shipment: function(tmsShipment, i) {
    const documentId = this.props.document.id;
    const isChecked = this.isShipmentDocument(tmsShipment, documentId);
    const isDisabled = !isChecked && this.hasAnyOtherDocumentsFromLoad(tmsShipment, documentId);
    const onChange = _.partial(
      this.props.toggleShipmentDocument,
      tmsShipment,
      this.props.document
    );
    const cssClasses = bem({
      "__assign-documents-selector-item-label": true,
      "__assign-documents-selector-item-label--disabled": isDisabled
    });
    const metaData = this.shipmentMetadata(tmsShipment);
    let Drops = null;
    const dropsInfo = tmsShipment.drops.map((drop) => ({
      id: drop.id,
      text: formatDropInfo(drop)
    }));
    if (dropsInfo.length > 1) {
      const DropItems = dropsInfo.map(({ id, text }) => /* @__PURE__ */ React.createElement("li", { key: id }, "Drop: ", /* @__PURE__ */ React.createElement("span", { className: "shipment-selector__drop-info" }, text)));
      Drops = /* @__PURE__ */ React.createElement("ul", { className: "shipment-selector__drops-info" }, DropItems);
    } else if (dropsInfo.length == 1) {
      Drops = /* @__PURE__ */ React.createElement("span", { className: "shipment-selector__drop-info" }, " ", "@ ", dropsInfo[0].text);
    }
    return /* @__PURE__ */ React.createElement("div", { key: "delivery-" + i }, /* @__PURE__ */ React.createElement("label", { className: cssClasses }, /* @__PURE__ */ React.createElement("span", { className: bem("__item-index") }, i + 1 + ")", "\xA0"), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: bem("__assign-documents-selector-checkbox"),
        checked: isChecked,
        onChange,
        type: "checkbox"
      }
    ), "\xA0", tmsShipment.shipment_id, " ", metaData, Drops));
  },
  shipmentMetadata(tmsShipment) {
    var accountSettings = Api.Account.currentSettings();
    if (accountSettings.primary_shipment_reference_label) {
      const refValue = tmsShipment.references[accountSettings.primary_shipment_reference_label];
      return refValue ? " - " + refValue : " ";
    } else {
      const originNameText = tmsShipment.origin_name;
      const weight = generalFormatter.weight(tmsShipment.weight);
      const pickupNumber = tmsShipment.references["Pickup Number"];
      return /* @__PURE__ */ React.createElement("span", null, pickupNumber, " ", originNameText || weight ? "@" : "", " ", originNameText, " ", weight);
    }
  }
});
